// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { injectCss } from "@insite/mobius/utilities";
import { LazyImage, mapStateToProps, Props } from "@vanmeter/MobiusOverrides/LazyImage";
import React from "react";
import { connect } from "react-redux";
import styled, { ThemeContext, withTheme } from "styled-components";

const LazyPictureStyle = styled.picture<any>`
    max-height: 100%;
    max-width: 100%;
    img {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
    }
    ${injectCss}
`;
/**
 * Xng Picture Component
 */
export class LazyPicture extends LazyImage {
    static contextType = ThemeContext;
    declare context: React.ContextType<typeof ThemeContext>;

    componentDidUpdate(prevProps: Props) {
        if (
            this.props.largeImageSrc !== prevProps.largeImageSrc ||
            this.props.mediumImageSrc !== prevProps.mediumImageSrc ||
            this.props.smallImageSrc !== prevProps.smallImageSrc
        ) {
            this.reloadImage();
        }
    }

    hasInvalidProps() {
        const { largeImageSrc, mediumImageSrc, smallImageSrc } = this.props as Props;
        return !largeImageSrc && !mediumImageSrc && !smallImageSrc;
    }

    renderImage(src?: string, fromPic?: boolean) {
        const { pictureProps, largeImageSrc, mediumImageSrc, smallImageSrc } = this.props as Props;

        return (
            <LazyPictureStyle {...pictureProps}>
                <source
                    media={`(min-width: ${this.context.breakpoints.values[3]}px)`}
                    srcSet={this.getImgUrl(largeImageSrc)}
                />
                <source
                    media={`(min-width: ${this.context.breakpoints.values[2]}px)`}
                    srcSet={this.getImgUrl(mediumImageSrc)}
                />
                <source
                    media={`(max-width: ${this.context.breakpoints.values[2]}px)`}
                    srcSet={this.getImgUrl(smallImageSrc)}
                />
                {super.renderImage(smallImageSrc)}
            </LazyPictureStyle>
        );
    }
}
/** @component */
export default withTheme(connect(mapStateToProps)(LazyPicture));
